/* REVIEW */
export const GET_REVIEW_LISTING = "GET_REVIEW_LISTING"
export const GET_REVIEW_LISTING_SUCCESS = "GET_REVIEW_LISTING_SUCCESS"
export const GET_REVIEW_LISTING_FAIL = "GET_REVIEW_LISTING_FAIL"

export const GET_REVIEW_DETAILS = "GET_REVIEW_DETAILS"
export const GET_REVIEW_DETAILS_SUCCESS = "GET_REVIEW_DETAILS_SUCCESS"
export const GET_REVIEW_DETAILS_FAIL = "GET_REVIEW_DETAILS_FAIL"

export const GET_REVIEW_APPROVAL = "GET_REVIEW_APPROVAL"
export const GET_REVIEW_APPROVAL_SUCCESS = "GET_REVIEW_APPROVAL_SUCCESS"
export const GET_REVIEW_APPROVAL_FAIL = "GET_REVIEW_APPROVAL_FAIL"

export const GET_REVIEW_EXPORT = "GET_REVIEW_EXPORT"
export const GET_REVIEW_EXPORT_SUCCESS = "GET_REVIEW_EXPORT_SUCCESS"
export const GET_REVIEW_EXPORT_FAIL = "GET_REVIEW_EXPORT_FAIL"

export const RESET_REVIEW_STATE = 'RESET_REVIEW_STATE';

export const RESET_REVIEW_DOCUMENT_STATE = 'RESET_REVIEW_DOCUMENT_STATE';